import React from "react";
import {
  HeaderTitle,
  SubmissionContainer,
  SubmissionHeader,
  CloseButton,
  ButtonGroup,
  RightButton
} from "./practice-answer-submission.styles";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import { Icon } from "design-system/components/icon/icon";

export interface PracticeAnswerSubmissionProps {
  children: React.ReactNode;
  onCapture?: () => void;
  onCancel?: () => void;
  onTutorial?: () => void;
  primaryLabel?: string;
  showCaptureIcon?: boolean;
}

export const PracticeAnswerSubmission: React.FC<
  PracticeAnswerSubmissionProps
> = ({
  children,
  onCapture,
  onCancel,
  onTutorial,
  primaryLabel = "Ambil Foto",
  showCaptureIcon = true
}) => {
  return (
    <SubmissionContainer>
      <SubmissionHeader>
        <HeaderTitle>Kirim Jawaban</HeaderTitle>
        <CloseButton
          type="button"
          aria-label="Tutup kirim jawaban"
          onClick={onCancel}
        >
          <Icon name="action-close" />
        </CloseButton>
      </SubmissionHeader>
      {children}
      <ButtonGroup>
        <Button
          appearance="general"
          variant="ghost"
          size={ButtonSize.lg}
          onClick={onTutorial}
        >
          <Icon name="general-info" /> Cara mengerjakannya
        </Button>
        <RightButton>
          <Button
            appearance="general"
            variant="secondary"
            size={ButtonSize.lg}
            onClick={onCancel}
          >
            Batalkan
          </Button>
          <Button
            appearance="general"
            variant="primary"
            size={ButtonSize.lg}
            onClick={onCapture}
          >
            {showCaptureIcon && <Icon name="general-camera" />} {primaryLabel}
          </Button>
        </RightButton>
      </ButtonGroup>
    </SubmissionContainer>
  );
};
